let timer = 0
const timeoutDelay = (func, funcVal, timeout) => {
	timer && clearTimeout(timer)
	timer = setTimeout(() => func(funcVal), timeout)
}

export default timeoutDelay
